import { useQuery } from '@tanstack/react-query'

import { getVcnCardMetrics } from '../../../api/vcn-management-api-client'

export const VCN_CARD_METRICS_QUERY_KEY = 'vcn-card-metrics'

/**
 * Card Mode's tile numbers. Its own key, separate from the benefit-unit
 * `migration-summary`: the two tabs show different entities and must be able to
 * refetch independently.
 *
 * The key belongs in `useInvalidateVcnData` as well — terminating a card changes
 * these counts, and a tile still showing the pre-action number next to a grid
 * that has moved on is the exact mistrust this work is meant to end.
 */
export function useVcnCardMetrics() {
  return useQuery({
    queryKey: [VCN_CARD_METRICS_QUERY_KEY],
    queryFn: getVcnCardMetrics,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  })
}
